import { FormState } from "react-hook-form";

export const isInvalid = (formState: FormState<any>, field: string) => {
  return !!formState.errors[field];
};
